import React from 'react';
import { FadeIn } from './FadeIn';
export function MechanismSection() {
  const steps = [{
    num: '01',
    title: 'Prepara preguntas estratégicas antes de la entrevista'
  }, {
    num: '02',
    title: 'Escucha con atención para identificar las necesidades, metas y preocupaciones reales del puesto'
  }, {
    num: '03',
    title: 'Adapta tus respuestas y pitch personal para mostrar por qué eres el candidato ideal'
  }];
  return <section className="py-20 lg:py-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-118">
      <FadeIn data-id="element-119">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-120">
          <h2 className="text-3xl md:text-4xl font-extrabold text-navy mb-4 tracking-tight" data-id="element-121">
            La clave no está en responder mejor. Está en preguntar mejor.
          </h2>
          <p className="text-xl text-emerald font-semibold" data-id="element-122">
            Conoce el Método de la Conversación Estratégica
          </p>
        </div>
      </FadeIn>

      <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-123">
        {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-124">
            <div className="bg-white p-8 rounded-2xl border border-gray-200 shadow-sm h-full relative overflow-hidden group hover:border-emerald transition-colors" data-id="element-125">
              <div className="text-6xl font-extrabold text-lightGray absolute -top-4 -right-4 group-hover:text-emerald/10 transition-colors" data-id="element-126">
                {step.num}
              </div>
              <div className="text-emerald font-bold text-2xl mb-4 relative z-10" data-id="element-127">
                Paso {step.num}
              </div>
              <p className="text-navy font-medium text-lg relative z-10" data-id="element-128">
                {step.title}
              </p>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.6} data-id="element-129">
        <div className="bg-emerald/10 border border-emerald/20 rounded-xl p-6 text-center max-w-3xl mx-auto" data-id="element-130">
          <p className="text-navy font-bold text-lg md:text-xl" data-id="element-131">
            "Cuando entiendes el dolor del puesto, puedes vender tu experiencia
            con precisión."
          </p>
        </div>
      </FadeIn>
    </section>;
}